exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ConfirmPopup_Caution_34SsH {\n    color: red;\n    fontSize:16px;\n    paddingBottom: 5px;\n}\n\n.ConfirmPopup_Warning_W2QKj {\n    color: black;\n    fontSize:16px;\n    paddingBottom: 5px;\n}\n\n.ConfirmPopup_ButtonDiv_xwEQz {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n\n.ConfirmPopup_ConfirmPopupDiv_13mxH {\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    padding: 20px 5px 10px 5px;\n}", ""]);

// Exports
exports.locals = {
	"Caution": "ConfirmPopup_Caution_34SsH",
	"Warning": "ConfirmPopup_Warning_W2QKj",
	"ButtonDiv": "ConfirmPopup_ButtonDiv_xwEQz",
	"ConfirmPopupDiv": "ConfirmPopup_ConfirmPopupDiv_13mxH"
};